import React from 'react';

const IconKeamananAkun = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 13.8293C14.1652 13.4175 15 12.3062 15 11C15 9.34315 13.6569 8 12 8C10.3431 8 9 9.34315 9 11C9 12.3062 9.83481 13.4175 11 13.8293V15.5C11 16.0523 11.4477 16.5 12 16.5C12.5523 16.5 13 16.0523 13 15.5V13.8293ZM12 12C12.5523 12 13 11.5523 13 11C13 10.4477 12.5523 10 12 10C11.4477 10 11 10.4477 11 11C11 11.5523 11.4477 12 12 12Z"
        fill="#06090D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5471 3.10842C11.8317 2.96386 12.1683 2.96386 12.4529 3.10842L20 6.94189V7.5903C20 9.34018 20 10.8755 19.8871 12.2094C19.7728 13.5587 19.5388 14.7716 19.0324 15.8648C17.991 18.1129 15.9349 19.5711 12.356 20.9345L12 21.0701L11.644 20.9345C8.0651 19.5711 6.00904 18.1129 4.96763 15.8648C4.46124 14.7716 4.2272 13.5587 4.11294 12.2094C3.99999 10.8755 4 9.34024 4 7.59031V6.94189L11.5471 3.10842ZM12 5.12161L6.0002 8.16913C6.0016 9.68309 6.01302 10.9448 6.10581 12.0406C6.21031 13.2747 6.41376 14.2284 6.78237 15.0241C7.46588 16.4996 8.83357 17.6763 12 18.9274C15.1664 17.6763 16.5341 16.4996 17.2176 15.0241C17.5862 14.2284 17.7897 13.2747 17.8942 12.0406C17.987 10.9448 17.9984 9.68309 17.9998 8.16913L12 5.12161Z"
        fill="#06090D"
      />
    </svg>
  );
};

export default IconKeamananAkun;
